import React from "react";
import { setPageName } from "../redux/actions";
import { useDispatch } from "react-redux";
import { goPage } from "../system/coords";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

// Images
const MattComputer = "/assets/images/matt-computer.png";
const ArrowIcon = "/assets/images/arrow.svg";

const Accordion = styled(props => <MuiAccordion disableGutters elevation={0} square {...props} />)(() => ({
  backgroundColor: "transparent",
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled(props => (
  <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
  color: "rgba(255, 255, 255, 1)",
  paddingLeft: 0,
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    color: "rgba(255, 255, 255, 1)",
  },
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
    transform: "rotate(90deg)",
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: 0,
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  backgroundColor: "rgba(0, 0, 0, .1)",
  fontSize: "0.8em",
}));

const AboutContent = () => {
  const numYears = new Date().getFullYear() - 1999;
  const dispatch = useDispatch();

  const [expanded, setExpanded] = React.useState("panel0");

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <div className="About h-70">
        <img src={MattComputer} className="MattComputer" alt="Matt sat at computer, working hard" />
        <h1>
          Hey <span className="hide-1080">there</span>
        </h1>
        <p>
          {/*
          Global web app development and cyber security expertise provider, particularly in the security and defence
          sectors - Matt Pass has been providing solutions since 2015 and since 1999 professionally, for end clients
          such as British Airways, DCMS, SANS, UK and USA government bodies. Responsible for teaching cyber security
          skills to over 250k users online and at many in-person events; to help keep the UK and USA safer online by
          developing future generations of cyber security professionals. A proud GIAC advisory board member, GPEN
          certified penetration tester, GitHub Advanced Security professional and now, proud ADS member.
          */}
          {/* eslint-disable-next-line max-len */}
          I'm a <strong>full stack developer</strong> with <strong>{numYears}+ years</strong> experience. This includes{" "}
          <strong>frontend</strong>, <strong>backend</strong>, <strong>devops</strong>, <strong>databases</strong>,{" "}
          <strong>cyber security</strong>, <strong>scripting</strong>, <strong>design</strong> and{" "}
          <strong>management</strong> skills. I've the ability to build entire apps by myself and have built 100's solo
          during my career but I'm also very happy working in a team and due to my wide ranging knowledge, act as a good
          middleman and leader.
          <br />
          <br />
          Below you can find some info on myself, or just head to the{" "}
          <span
            style={{ color: "#fff", cursor: "pointer" }}
            onClick={() => {
              goPage("Tech");
              dispatch(setPageName("Tech"));
            }}
          >
            Tech
          </span>{" "}
          or{" "}
          <span
            style={{ color: "#fff", cursor: "pointer" }}
            onClick={() => {
              goPage("Demos");
              dispatch(setPageName("Demos"));
            }}
          >
            Demos
          </span>{" "}
          sections. They contains less words and are more fun! :)
        </p>
        <div className="About-content-1">
          <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
              <Typography component="span">General Overview</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ fontSize: "1em" }}>
                My aim in all I do is to build excellent apps, on schedule and to specification, I have the skills and
                expertise to build just about anything that may be required and if I don't know how, I'll seek good
                sources and learn! My focus is to ensure solutions are as secure as possible, maintainable, documented
                and expandable for the future.{" "}
              </Typography>
              <Typography sx={{ fontSize: "1em" }}>
                I started my career in the dot-com boom & bust of the late 90's and even today I still absolutely love
                what I do. I'm an enthusiastic, driven person who's always innovating and learning, which is why I've a
                long career and varied set of skills, which I use in combination daily to get the desired results.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
            <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
              <Typography component="span">Career</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ fontSize: "1em" }}>
                From Feb 1999 to Apr 2013 roles included Digital Director, Senior Web Designer, Creative Director and
                Lead Web Designer. I led the spec, design & build for many clients for web design consultancies,
                producing many sites & apps including solutions for clients such as British Airways and Reebok, built an
                e-commerce site that turned over £4m+ per year, was featured in BBC review on TV, operated PPC
                advertising for 25 clients, ran my own company which I turned from zero to profitable and later merged.
                Since then I've picked up many additional skills including database management, devops, cyber security
                abilities and more. I'm{" "}
                <a
                  href="https://www.credly.com/badges/2db2fef1-2008-42a4-a864-439642cf7a6c"
                  target="_blank"
                  rel="noreferrer"
                >
                  GitHub Advanced Security
                </a>{" "}
                certified and an{" "}
                <a href="https://www.adsgroup.org.uk/members/matt-pass/" target="_blank" rel="noreferrer">
                  ADS Group
                </a>{" "}
                member.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="About-content-2">
          <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
              <Typography component="span">Projects</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ fontSize: "1em" }}>
                I've built 450+ web sites & apps for approx 300 businesses. including BBC R&D, Ecotricity, SANS and
                more. I'm proud to have built cyber security games to teach 250k+ users binary, cyptography, forensics,
                networking and web skills for{" "}
                <a href="https://cyberstart.com" target="_blank" rel="noreferrer">
                  CyberStart
                </a>
                . Oh, I also built{" "}
                <a href="https://icecoder.net" target="_blank" rel="noreferrer">
                  ICEcoder
                </a>{" "}
                a while back, which is a browser based code editor that's been used by some really big companies.
              </Typography>
              <Typography className="mobile-hide" sx={{ fontSize: "1em" }}>
                Some other things I've built include a Powerpoint to HTML parser, an image extraction microservice, a
                full featured web based vector graphics app, my own Sage connected ecommerce platform, CTF events (one
                worth $8 million in prizes for US schools), educational content for UK, US and UAE governments, an
                aptitude testing system at GCHQ, written interactive tutorials for C and Python languages and much more.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
            <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
              <Typography component="span">Interests</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ fontSize: "1em" }}>
                I'm happiest when breaking new ground, pushing my abilities and producing the very best I can for the
                end user (always my top priority) and I'll put the extra effort in if it provides a better UI/UX. I'm
                quite self-sufficient and can produce solutions solo, though quite happy to work with others and can
                produce solutions in a team. Because of my long & varied history, I make quite a good middleman between
                teams.
              </Typography>
              <Typography className="mobile-hide" sx={{ fontSize: "1em" }}>
                I’m an ideal person to take on the more complex tasks, as I can break down and action them effectively
                into logical stages which I’m happy to plan out as technical solutions, love learning with others and
                happy pair programming when things get tricky. I really enjoy perfecting my tech setup and creating
                solutions to improve developer workflow such as linting, testing and CI/CD to ever improve quality,
                robustness and dependability plus writing tools for efficiency.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
      <img
        src={ArrowIcon}
        className="Arrow-icon Arrow-About"
        alt="Go to next page"
        onClick={() => {
          goPage("Clients");
          dispatch(setPageName("Clients"));
        }}
      />
    </>
  );
};

export default AboutContent;
